module.exports = __webpack_public_path__ + "media/images/favicon/secondary/apple-icon-180x180-f4089174a68dd668242fa6894ccb6671.png";